import { cssPrefix } from '../../../../const/Constant';
import { XScreenZone } from './XScreenZone';

class XScreenTZone extends XScreenZone {

  constructor() {
    super(`${cssPrefix}-x-screen-t-zone`);
  }

}

export {
  XScreenTZone,
};
